module.exports = __webpack_public_path__ + "img/FGr_Räumen_A_Bagger.6f55644d.svg";